import {Controller} from "@hotwired/stimulus"
export default class RoomController extends Controller {
  static targets = ['chatBox']

  scroll(){
    setTimeout(()=>{
      const chatBox = document.getElementById("chat-history");
      chatBox.scrollTop = chatBox.scrollHeight;
    }, 100)
  }

  connect() {
    globalThis.skipPopstate = true
    this.displayRoom()
    const messages = document.getElementById("chat-history");
    messages.scrollTop = messages.scrollHeight - messages.clientHeight;
  }

  displayRoom(){
    const userList = document.getElementById("user-list");
    const chatArea = document.getElementById("chat-area");
    const headerBackBtn = document.getElementById("header-back-btn");
    if (globalThis.innerWidth < 1399 && (chatArea && userList)) {
      userList?.classList?.add("d-none");
      chatArea?.classList?.remove("d-none");
      chatArea?.classList?.add("d-flex");
      headerBackBtn?.classList?.add("d-none");
    }
  }

  hideButtons(){
    $(".reply-btn").addClass('d-none')
  }

  showButtons(){
    $(".reply-btn").removeClass('d-none')
  }

  chatBoxTargetConnected() {
    if (globalThis.innerWidth <= 992) {
      this.popStateHandler = this.backClick.bind(this);
      globalThis.addEventListener('popstate', this.popStateHandler)
    }
  }

  chatBoxTargetDisconnected() {
    this.removePopStateListener()
  }

  backClick() {
    this.removePopStateListener();
    Turbo.visit("/messages")
  }

  removePopStateListener() {
    if (this.popStateHandler) {
      globalThis.removeEventListener('popstate', this.popStateHandler)
      this.popStateHandler = null
    }
  }
}
